import { createClient } from "@supabase/supabase-js";
import { runtimeConfig } from "./runtime-config";

const url = runtimeConfig.supabaseUrl;
const publishableKey = runtimeConfig.supabasePublishableKey;

export const supabaseConfigured = Boolean(url && publishableKey);

export const supabase = createClient(
  url || "http://127.0.0.1:54321",
  publishableKey || "missing-publishable-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
